export function updateObjectNestedProperties(
  obj: any,
  propertyValueMap: Record<string, any>
) {
  let updatedObject: typeof obj = { ...obj };

  for (const propertyPath in propertyValueMap) {
    if (propertyValueMap.hasOwnProperty(propertyPath)) {
      const value = propertyValueMap[propertyPath];
      const properties = propertyPath.split('.');

      let currentObject = updatedObject;
      for (let i = 0; i < properties.length - 1; i++) {
        const property = properties[i];
        currentObject[property] = { ...currentObject[property] };
        currentObject = currentObject[property];
      }

      const lastProperty = properties[properties.length - 1];
      currentObject[lastProperty] = value;
    }
  }

  return updatedObject;
}
